import Container from '@embracesbs/component-container/Container'
import Header from '@embracesbs/component-header/Header'
import Switch from '@embracesbs/component-switch'
import Toast, { customToast } from '@embracesbs/component-toast'
import React, { useEffect, useState } from 'react'
import { useApi, useAuth } from '../../../Hooks'
import { useTenants } from '../../Context/TenantContext'

interface SNSAccordionContentProps {}

const SNSAccordionContent: React.FC<SNSAccordionContentProps> = () => {
  const [notificationsDisabled, setNotificationsDisabled] = useState<boolean>(false)
  const { selectedTenantId, selectedTenant } = useTenants()
  const { fetchApi } = useApi()
  const { isLoggedIn } = useAuth()

  useEffect(() => {
    if (!isLoggedIn || selectedTenantId === null) return
    fetchNotificationsDisabled()
  }, [isLoggedIn, selectedTenantId])

  const fetchNotificationsDisabled = async () => {
    try {
      const response = await fetchApi({
        endpoint: `/api/appconfiguration/${selectedTenantId}/notifications-disabled:${selectedTenant.tenantName}/SNS`,
        method: 'GET'
      })
      setNotificationsDisabled(response === 'true' || response === true)
    } catch (error) {
      console.error('Failed to fetch notifications-disabled setting:', error)
    }
  }

  const headerStyle = {
    fontFamily: 'F-Default',
    fontWeight: 'bold',
    width: '100%'
  }

  const sectionContainerStyle = {
    marginBottom: '25px',
    padding: '15px',
    background: 'var(--tma-card-bg)',
    borderRadius: '8px'
  }
  const innerContainerStyle = {
    marginBottom: '0px'
  }

  const handleToggleNotificationsDisabled = async () => {
    const newValue = !notificationsDisabled
    try {
      await fetchApi({
        endpoint: `/api/appconfiguration/${selectedTenantId}`,
        method: 'POST',
        body: {
          key: `notifications-disabled:${selectedTenant.tenantName}`,
          value: String(newValue),
          label: 'SNS'
        }
      })
      setNotificationsDisabled(newValue)
      customToast.success('Shared Notification Service setting saved')
    } catch (error) {
      customToast.error('Failed to save Shared Notification Service setting')
      console.error(error)
    }
  }

  const renderSharedNotificationServiceSettings = () => {
    return (
      <Container isVertical align='center' gap={0} spacing={0} isFullWidth style={sectionContainerStyle}>
        <Header style={headerStyle}>Shared Notification Service settings</Header>
        <Toast />
        <Container align='center' gap={0} spacing={0} isFullWidth style={innerContainerStyle}>
          <Switch
            name='notifications-disabled'
            label='Disable notifications'
            value='a'
            onClick={handleToggleNotificationsDisabled}
            isChecked={notificationsDisabled}
          />
        </Container>
      </Container>
    )
  }

  return <>{renderSharedNotificationServiceSettings()}</>
}

export default SNSAccordionContent
